import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  getMaxWidthContainerParent,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/styles';
import Typography from 'Components/UI/Typography';
import useMobileLayout from 'Hooks/useMobileLayout';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import EditIcon from '@material-ui/icons/Edit';
import fr from 'facet-rest';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FAQButton from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/FAQButton';
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';
import useDebugPanel from 'Components/UI/DebugPanel/useDebugPanel';
import Divider from 'Components/UI/Divider';
import ManagedAccountFundingInstructionCtaCard
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Content/ManagedAccountFundingInstructionCtaCard';
import { FDBox, FDContentContainer } from '@facet-wealth/design';
import SyncIcon from '@material-ui/icons/Sync';
import classNames from 'classnames';
import DeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDModal/Layout/DeleteButton';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import ManagedAccountPageTabs from './ManagedAccountPageTabs';
import ManagedAccountPageInfoBar from './ManagedAccountPageInfoBar';

const useStyles = buildUseStyles('ManagedAccountPageTopBar', (theme) => ({
  root: {
    ...getMaxWidthContainerParent({ theme }),
  },
  mobileRoot: {
    paddingBottom: theme.spacing(2),
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  mobileTitle: {
    fontSize: theme.typography.fontSize1Pt125Rem,
    marginRight: theme.spacing(1),
  },
  desktopTitle: {
    fontSize: theme.typography.fontSize1Pt625Rem,
    marginRight: theme.spacing(1),
  },
}));


export default function ManagedAccountPageTopBar({ resource }) {
  const isMobile = useMobileLayout();
  const {
    showing,
  } = useDebugPanel();

  const classes = useStyles();
  const { loadModalCollectionByLink } = useModalContext();
  const { loadPageContentLink } = usePageContentContext();

  const canEditNickname = Boolean(resource?.relationship(fr.relationships.nickname.name)?.link('related')) === true;

  const handleEditClick = async () => {
    await loadModalCollectionByLink(resource?.relationship(fr.relationships.nickname.name)?.link('related').url());
  };

  const handleDownloadClick = async () => {
    window.open(resource?.relationship(fr.relationships.export.name)?.link('related').url(), '_blank', 'noreferrer noopener nofollow');
  };
  const handleSyncClick = async () => {
    await resource?.relationship(fr.relationships.devOnlySyncWithAggregator.name)?.link('related').post({}, {
      raw: true, deprecatedAllowAlterOfRelation: true,
    });
  };

  const handleCloseAccountClick = async () => {
    await resource?.relationship(fr.relationships.closeAccount.name)?.link('related').post({}, {
      raw: true, deprecatedAllowAlterOfRelation: true,
    });
  };

  const TitleComponent = () => {
    return (
      <div className={classes.titleContainer}>
        <Typography
          color="darkGray"
          className={classNames(classes.title, {
            [classes.mobileTitle]: isMobile,
            [classes.desktopTitle]: !isMobile,
          })}
          weight="medium"
          test="manage-account-page-title"
        >
          {resource.attr('name')}
        </Typography>
        {canEditNickname ? <IconButton
          icon={EditIcon}
          color={'naturalGreen'}
          size={'small'}
          onClick={async () => handleEditClick()}
        /> : null}
        {resource?.relationship(fr.relationships.export.name) && showing && (
          <IconButton
            icon={DownloadIcon}
            color={'naturalGreen'}
            size={'small'}
            onClick={async () => handleDownloadClick()}
          />
        )}
        {resource?.relationship(fr.relationships.devOnlySyncWithAggregator.name) && showing && (
        <IconButton
          icon={SyncIcon}
          color={'naturalGreen'}
          size={'small'}
          onClick={async () => handleSyncClick()}
        />
        )}
        {resource?.relationship(fr.relationships.closeAccount.name) && (

        <DeleteButton
          onDelete={handleCloseAccountClick}
          onDeleteSuccess={() => {
            loadPageContentLink(resource.relationship(fr.relationships.previousPage.name).link('related'));
          }}
          dialogProps={{
            title: 'Are you sure you want to remove this account?',
            message: 'This cannot be undone. The member will need to open a new account from through a new account task. All funding actions that have been taken thus far will also need to be recreated and re-submitted.',
            confirmLabel: 'Remove',
          }}
        />
        )}
      </div>
    );
  };

  return <>
    <Box className={classNames(classes.root, { [classes.mobileRoot]: isMobile })}>
      <FDContentContainer maxWidth="xl" data-test="managed-account-page-top-bar">
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <TitleComponent />
          {!!resource.relationship(fr.relationships.faq.name) && <>
            <FAQButton
              link={resource.relationship(fr.relationships.faq.name).link('related')}
              text={'Help'}
            />
          </>}
        </Box>
        <ManagedAccountPageInfoBar resource={resource} />
        {resource.relationship(fr.relationships.fundingInstructionCta.name) ? <>
          <FDBox paddingY={2}>
            <ManagedAccountFundingInstructionCtaCard
              ctaRelationship={resource.relationship(fr.relationships.fundingInstructionCta.name)}
            />
          </FDBox>
        </>
          : <Divider />}

        <ManagedAccountPageTabs />
      </FDContentContainer>
    </Box>
  </>;
}
